import React, { useEffect } from "react";
import styles from "./style.module.scss";
import { useDomainContext } from "@hooks/useDomainContext";
import { convertToBreakpointVariables } from "@page-builder/utils";

export default function PreHeader({
    text,
}: {
    text: string;
}): React.ReactElement {
    useEffect(() => {
        window.scrollTo(0, 24);
    }, []);

    const { routeConfig } = useDomainContext();
    const variables = routeConfig?.config?.header?.variables;

    return (
        <div
            style={
                variables && {
                    ...convertToBreakpointVariables(variables),
                }
            }
            className={styles.preHeader}
        >
            {text}
        </div>
    );
}
